import { combineReducers } from 'redux';

import dvrToolkitPasswordStep from './reducer/dvrToolkitPasswordStep';
import serviceAccountStep from './reducer/serviceAccountStep';

export default combineReducers({
  dvrToolkitPasswordStep,
  serviceAccountStep,
});
